import React from 'react';
import PropTypes from 'prop-types';
import './CardActions.css';

/**
 * A component for displaying card action buttons/controls at the top of a page
 * Using BEM naming convention for CSS classes
 */
const CardActions = ({
  leftActions,
  rightActions,
  className = ''
}) => {
  if (!leftActions && !rightActions) {
    return null;
  }
  
  return (
    <div className={`card-actions ${className}`}>
      <div className="card-actions__container">
        {leftActions && (
          <div className="card-actions__left">
            {leftActions}
          </div>
        )}
        
        {rightActions && (
          <div className="card-actions__right">
            {rightActions}
          </div>
        )}
      </div>
    </div>
  );
};

CardActions.propTypes = {
  leftActions: PropTypes.node,
  rightActions: PropTypes.node,
  className: PropTypes.string
};

export default CardActions;